import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../../../common/button/button.module';
import { DateModule } from './../../../common/date/date.module';
import { HeadingModule } from './../../../common/heading/heading.module';
import { IconModule } from './../../../common/icon/icon.module';
import { DialogBodyModule } from './../../../dialog/dialog-body/dialog-body.module';
import { RtUIPdfViewerModule } from './../../../pdf-viewer/pdf-viewer.module';
import { AttachmentPreviewDialogComponent } from './attachment-preview-dialog.component';

@NgModule({
  declarations: [AttachmentPreviewDialogComponent],
  exports: [AttachmentPreviewDialogComponent],
  imports: [
    DialogBodyModule,
    HeadingModule,
    DateModule,
    IconModule,
    I18nModule,
    CommonModule,
    RtUIPdfViewerModule,
    ButtonModule,
  ],
})
export class AttachmentPreviewDialogModule {}

export { AttachmentPreviewDialogComponent } from './attachment-preview-dialog.component';
